import {
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
} from "../../pages/landingPage/components/header/styles";
import { useLanguagePicker } from "../../pages/landingPage/components/header/hooks/useLanguagePicker.hook";
import { DownOutlined, UpOutlined } from "ui";
import { CSSProperties } from "react";

interface HeaderProps {
  showButtons: boolean;
  compact?: boolean;
  className?: string;
}

export const LanguageSwitcher = ({
  showButtons,
  compact = false,
  className,
}: HeaderProps) => {
  void showButtons;
  const {
    currentLanguage,
    handleDropdownClick,
    handleChangeLanguage,
    isLanguageMenuOpen,
    languages,
    ref,
  } = useLanguagePicker();
  const languagePickerIcon = isLanguageMenuOpen ? (
    <UpOutlined />
  ) : (
    <DownOutlined />
  );
  const compactDropdownStyle: CSSProperties | undefined = compact
    ? {
        minWidth: 56,
        minHeight: 46,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        padding: "0 14px",
        border: "1px solid #E2E7EF",
        borderRadius: 999,
        backgroundColor: "#F4F6FB",
        font: '600 14px/1 "Roboto", sans-serif',
      }
    : undefined;
  const compactMenuStyle: CSSProperties | undefined = compact
    ? {
        left: "50%",
        transform: "translateX(-50%)",
        minWidth: 110,
        borderRadius: 10,
        padding: "4px 0",
      }
    : undefined;
  const compactMenuItemStyle: CSSProperties | undefined = compact
    ? {
        textAlign: "center",
        padding: "8px 12px",
      }
    : undefined;

  return (
    <Dropdown
      className={className}
      ref={ref}
      $isLanguageMenuOpen={isLanguageMenuOpen}
      style={compactDropdownStyle}
      onClick={handleDropdownClick}
    >
      <span style={{ pointerEvents: "none" }}>{currentLanguage.label}</span>
      <span
        aria-hidden="true"
        style={{
          pointerEvents: "none",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        {languagePickerIcon}
      </span>
      {isLanguageMenuOpen && (
        <DropdownMenu
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          style={compactMenuStyle}
          onClick={(event: React.MouseEvent) => event.stopPropagation()}
        >
          {languages.map((lang) => (
            <DropdownMenuItem
              key={lang.value}
              style={compactMenuItemStyle}
              onClick={(event: React.MouseEvent) => {
                event.stopPropagation();
                void handleChangeLanguage(lang.value)();
              }}
            >
              {lang.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      )}
    </Dropdown>
  );
};
